import { render, staticRenderFns } from "./CodeCanvas.vue?vue&type=template&id=0c393fc1&"
import script from "./CodeCanvas.vue?vue&type=script&lang=js&"
export * from "./CodeCanvas.vue?vue&type=script&lang=js&"
import style0 from "./CodeCanvas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports